import { render, staticRenderFns } from "./TierComparison.vue?vue&type=template&id=485f244f&scoped=true&"
import script from "./TierComparison.vue?vue&type=script&lang=js&"
export * from "./TierComparison.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485f244f",
  null
  
)

export default component.exports